
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import FacturePDF from '../../components/facture-pdf/FacturePDF';
import { useNavigate, useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { COLORS } from '../../settings/themeSettings';
import WestIcon from '@mui/icons-material/West';
import { Stack, Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDevis } from '../../data/slices/devisSlice';
import DevisPDF from '../../components/facture-pdf/DevisPDF';



const DevisViewer = ({}) => {

    const { id, clientId} = useParams();
    const navigateTo = useNavigate();

    const {devis, fetchDevisStatus} = useSelector((state) => state.devis);
    const dispatch = useDispatch();
    const [bankOption, setBankOption] = useState('sgbs');
    const [deviseOption, setDeviseOption] = useState('euro');

    
        useEffect(() => {
            if(devis == null) dispatch(fetchDevis(id));
        }, []);

    return <div>
        <Stack
            direction="row"
            justifyContent="flex-start"
            gap="5"
            alignItems="flex-start"

        >
            <div onClick={() => navigateTo(`/billeterie/devis/${clientId}/details/${id}`)}
                style={{ background: COLORS.secondary, height: '65px', width: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: `${65 / 2}px`, cursor: 'pointer' }}>
                <WestIcon style={{ fill: 'white', fontSize: 28 }} />
            </div>
            <Typography variant="h4" sx={{ backgroundColor: COLORS.secondary, color: '#FFF', p: '10px', mb: 5, ml: 5, width: '100%' }}>Devis PDF </Typography>

        </Stack>

{
    fetchDevisStatus == 'loading' ?
    <div className="loader-container">
                    <span className="loader"></span>
                </div>

                :
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100vh' }}>
                  <div style={{ padding: '0 20px 20px 20px' }}>
                      <FormControl component="fieldset">
                          <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>Coordonnées Bancaires à afficher :</FormLabel>
                          <RadioGroup
                              row
                              value={bankOption}
                              onChange={(e) => setBankOption(e.target.value)}
                          >
                              <FormControlLabel value="sgbs" control={<Radio color="primary" />} label="SGBS" />
                              <FormControlLabel value="orabank" control={<Radio color="primary" />} label="Orabank" />
                              <FormControlLabel value="none" control={<Radio color="primary" />} label="Cacher la banque" />
                          </RadioGroup>
                      </FormControl>
                      <FormControl component="fieldset" sx={{ ml: 4 }}>
                          <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>Devise :</FormLabel>
                          <RadioGroup
                              row
                              value={deviseOption}
                              onChange={(e) => setDeviseOption(e.target.value)}
                          >
                              <FormControlLabel value="cfa" control={<Radio color="primary" />} label="Franc CFA" />
                              <FormControlLabel value="euro" control={<Radio color="primary" />} label="Euro" />
                              <FormControlLabel value="both" control={<Radio color="primary" />} label="Les deux" />
                          </RadioGroup>
                      </FormControl>
                  </div>
                  <PDFViewer style={{width: '100%', flex: 1}} >
                      <DevisPDF devis={devis} bankOption={bankOption} deviseOption={deviseOption} /> 
                  </PDFViewer>
              </div>
}
        

       

    </div>

}



export default DevisViewer;
